/*
 *   File : ipv-success.js
 *   Author URI : https://evoqins.com
 *   Description : Modal for showing payment status. 
 *   Integrations : null
 *   Version : v1.1
 */

import { useEffect, useState } from "react";

import Icon from "../Icon/icon";

import style from "../../Styles/Component/cancel-sip.module.scss";

const IPVSuccess = (props) => {

    useEffect(() => {
        var my_modal = document.getElementById("ipv-status");
        my_modal.addEventListener("hidden.bs.modal", () => {
            props.close();
        });
    }, []);

    useEffect(() => {
        var my_modal = document.getElementById("ipv-status");
        my_modal.addEventListener("shown.bs.modal", () => {
            setTimeout(()=>{
                _closeModal();
            },3000);
        });
    }, []);

    function _closeModal() {
        document.getElementById("close-modal").dispatchEvent(new Event("click"));
    }

    return (
        <div className={`modal fade ${style.e_sip_modal}`}
            id="ipv-status"
            tabIndex="-1"
            data-bs-backdrop="static"
            aria-labelledby="ipv-status"
            aria-hidden="true">
            <div className={`modal-dialog position-relative modal-dialog-centered ${style.e_dialog}`}>
                <div className={`modal-content bg-modal padding-32px-lr pb-3 ${style.e_content} `}>
                    <Icon icon="close"
                        size={24}
                        data-bs-dismiss="modal"
                        className={`position-absolute cursor-pointer e-modal-close-btn ${style.e_close}`} />
                        <span id="close-modal" data-bs-dismiss="modal" className='d-none'></span>
                    <div className="text-center">
                        <img src={require('../../Assets/Images/orders/order-success.svg').default }
                            alt="Pause SIP"
                            width={72}
                            height={72} />
                    </div>
                    <div className="row pb-4">
                        <div className="col-12 text-center">
                            <h5 className="color-eerie-black e-poppins-medium e-font-18 mt-5">
                                IPV Completed
                            </h5>
                            <p className="color-outer-space e-poppins-regular e-font-14 mb-0  text-center">
                                You successfully completed the IPV verification
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default IPVSuccess;